import {
	SandpackProvider,
	SandpackLayout,
	SandpackPreview,
	SandpackCodeEditor,
	SandpackFileExplorer,
	// Sandpack,
	SandpackFiles,
	useActiveCode,
	useSandpack,
	SandpackConsole,
} from '@codesandbox/sandpack-react';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { FC, useEffect, useRef, useState } from 'react';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import './CodeSandpack.scss';

type SandPackWrapperProps = {
	files?: SandpackFiles;
	field: IEntityContentField;
};

const SPtest = () => {
	const { code } = useActiveCode();
	const { sandpack } = useSandpack();
	const { files, activeFile } = sandpack;

	// console.log('activeFile: ', activeFile);
	// const codea = files[activeFile].code;
	// console.log(' const codea = files[activeFile].code;: ', codea);

	// console.log('raw: ', code, updateCode);
	useEffect(() => {
		console.log('activeFile: ', activeFile);
		console.log('files: ', files);
	}, [code]);
	return (
		<div>
			<span style={{ display: 'none' }}>1</span>
		</div>
	);
};

const SandPackWrapper: FC<SandPackWrapperProps> = ({ files, field }) => {
	const codeEditorI = useRef<any>();
	const [showFiles, setShowFiles] = useState<boolean>(false);
	const consoleMode = field.options?.consoleMode;
	const [showConsole, setShowConsole] = useState<boolean>(!!consoleMode);
	const showSave = false;
	const save = (): void => {
		// console.log(codeEditorI.current.getCodemirror());
	};

	// const input = (v: any) => console.log(v);

	const snippetMode = field.options?.snippetMode;
	const dependencies = field.options?.dependencies || {};
	const template = field.options?.template || 'react';

	return (
		<div>
			<SandpackProvider
				files={files}
				template={template}
				theme="dark"
				// onInput={input}
				customSetup={{
					dependencies: {
						...dependencies,
					},
				}}
				options={{ activeFile: field.options.mainFile || '' }}
			>
				<SandpackLayout>
					{showSave && <SPtest />}
					{showFiles && <SandpackFileExplorer />}
					<SandpackCodeEditor
						ref={codeEditorI}
						readOnly={snippetMode}
						showTabs
						showLineNumbers
						showInlineErrors
						wrapContent={false}
						className={snippetMode ? 'snippet-mode' : ''}
					/>
					{!snippetMode && (
						<>
							<SandpackPreview
								actionsChildren={
									<div>
										<button
											type="button"
											onClick={() => setShowFiles(!showFiles)}
											className="action-button icon"
										>
											<AccountTreeIcon fontSize="inherit" /> Files
										</button>
										<button
											type="button"
											onClick={() => setShowConsole(!showConsole)}
											className="action-button icon"
										>
											Console
										</button>
										{showSave && (
											<button type="button" onClick={save} className="action-button">
												Save
											</button>
										)}
									</div>
								}
								showOpenNewtab
							/>

							{showConsole && (
								<SandpackConsole
									actionsChildren={
										<div>
											<button
												type="button"
												onClick={() => setShowConsole(!showConsole)}
												className="action-button icon"
											>
												Close
											</button>
											{showSave && (
												<button type="button" onClick={save} className="action-button">
													Save
												</button>
											)}
										</div>
									}
								/>
							)}
						</>
					)}
				</SandpackLayout>
			</SandpackProvider>
		</div>
		// <Sandpack
		// 	files={files}
		// 	theme="dark"
		// 	template="react"
		// 	options={{
		// 		layout: 'preview', // preview | tests | console
		// 		showTabs: true,
		// 		initMode: 'lazy',
		// 		// closableTabs: true,
		// 	}}
		// />
	);
};

export default SandPackWrapper;
